export class SeasonDateRange{
    dateRangeId: number;
    tempId: number;
    endDate: any;
    startDate: any;
}